import React, { Component } from "react";
import Fade from "react-reveal";

class TShirts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isZoomedDamska: false,
      isZoomedMeska: false,
    };
  }

  toggleZoom = (which) => {
    this.setState((prevState) => ({
      [which]: !prevState[which],
    }));
  };

  render() {
    if (!this.props.data) return null;
    const tshirts = this.props.data.tshirts;
    const rozmiar_koszulek = "images/tabelka.png";
    const koszulka = "images/koszulka.png";
    const { isZoomed } = this.state;


    return (


      <section id="tshirts">
        <Fade duration={2000} distance="40px">

          <div className="row">
            
            <div className="six columns collapsed">
              
              <h2>{tshirts}</h2>
              <h3>projekt koszulki zatwierdzony <br/>
              koszulka funkcyjna na rowery poziome z przednią kieszenią<br/>
              cena 100 zł</h3>
              <h3>Tabele rozmiarów koszulek</h3>
         
            </div>
            <div>
             <img
                src={rozmiar_koszulek}
                alt="rozmiar_koszulek"
              />

              <img
                src={koszulka}
                alt="koszulka"
                className="tshirts-img"
              />
              </div>
          </div>
         
        </Fade>
        
      </section>

    );
  }
}

export default TShirts;
